

export default [

  {
    path: '/grouping-settings',
    meta: { label: 'General Settings' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'Grouping Settings',
        meta: {
          label: 'Grouping Settings',
          permission: 'show_settings_grouping_settings'
        },
        component: () => import('./../../views/groupings/settings/index.vue'),
      },
      {
        path: 'create',
        meta: { label: 'Grouping Setting Create', permission: 'show_settings_grouping_settings' },
        name: 'CreateGroupingSetting',
        component: () => import('./../../views/groupings/settings/create.vue'),
      },
      {
        path: ':id',
        meta: { label: 'Grouping Setting Details', permission: 'show_settings_grouping_settings' },
        name: 'GroupingSetting',
        component: () => import('./../../views/groupings/settings/show.vue'),
      },
      {
        path: ':id/edit',
        meta: { label: 'Edit Grouping Setting', permission: 'show_settings_grouping_settings' },
        name: 'EditGroupingSetting',
        component: () => import('./../../views/groupings/settings/edit.vue')
      },

    ]
  },
  {
    path: '/grouping-lines',
    meta: { label: 'Grouping Account Lines' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'Grouping Account Lines',
        meta: {
          label: 'Grouping Account Lines',
          permission: 'show_settings_account_lines_grouping'
        },
        component: () => import('./../../views/groupings/AccountLines/index.vue'),
      },
    ]
  },
  {
    path: '/grouping-account-doctors',
    meta: { label: 'Grouping Account Doctors' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'Grouping Account Doctors',
        meta: {
          label: 'Grouping Account Doctors',
          permission: 'show_settings_account_doctors_grouping'
        },
        component: () => import('./../../views/groupings/AccountDoctors/index.vue'),
      },
    ]
  },
  {
    path: '/grouping-request-types',
    meta: { label: 'Grouping Request Types' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'Grouping Request Types',
        meta: {
          label: 'Grouping Request Types',
          permission: 'show_settings_request_types_grouping'
        },
        component: () => import('./../../views/groupings/RequestTypes/index.vue'),
      },
    ]
  },
  {
    path: '/grouping-roles',
    meta: { label: 'Grouping Roles' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'Grouping Roles',
        meta: {
          label: 'Grouping Roles',
          permission: 'show_settings_roles_grouping'
        },
        component: () => import('./../../views/groupings/Roles/index.vue'),
      },
    ]
  },
];
